import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_ds_material_groups_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_material_groups_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_material_groups_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_material_groups_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string    }) {
      return false;
    }
}
